export const PrinterModel = {
  SUNMI_INTERNAL: 'sunmi_internal_printer',
  SUNMI_CLOUD: 'sunmi_cloud_printer',
  PDF: 'pdf',
  EPSON_BLUETOOTH: 'epson_bluetooth',
  STAR_BLUETOOTH: 'star_bluetooth',
  SUNMI_BLUETOOTH: 'sunmi_bluetooth',
} as const;

export type PrinterModelType = (typeof PrinterModel)[keyof typeof PrinterModel];

export interface Printer {
  id: number;
  printer_model: PrinterModelType;
  enabled: boolean;
  human_printer_model: boolean;
}

export interface PrintersResponse {
  printers: Printer[];
}
